<div class="content">
  <!-- Contacts -->
  <div
    id="contacts-list"
    fusePerfectScrollbar
    [fusePerfectScrollbarOptions]="{ suppressScrollX: true }"
  >
    <div
      *ngFor="let contact of contacts"
      class="contacts-list-item"
      [ngClass]="contact.status"
      [matTooltip]="contact.name"
      matTooltipPosition="left"
      (click)="onContactClick(contact)"
    >
      <!-- Avatar : photo si disponible, sinon initiales -->
      <img
        *ngIf="contact.avatar"
        class="avatar"
        [src]="contact.avatar"
        [alt]="contact.name"
        onerror="
          if (this.src !== '/assets/images/avatars/default-no-avatar.png')
            this.src = '/assets/images/avatars/default-no-avatar.png';
        "
      />
      <div *ngIf="!contact.avatar" class="avatar chat-initials-avatar accent">
        {{ contact.initials }}
      </div>

      <!-- Puce : nombre de messages non lus -->
      <div class="unread-count" *ngIf="contact.unread">
        {{ contact.unread }}
      </div>

      <!-- Pastille : présence -->
      <div class="status-icon" [ngClass]="contact.status"></div>
    </div>
  </div>
  <!-- / Contacts -->
</div>
